var baseStyleContainer = {
  borderRadius: 0
};
var baseStylePanel = {
  borderRadius: 0
};
var baseStyle = {
  container: baseStyleContainer,
  header: {
    borderRadius: 0,
    borderBottom: '1px',
    bg: 'grey.250',
    '&[data-open="false"]': {
      bg: 'grey.250'
    }
  },
  panel: baseStylePanel
};
export default {
  baseStyle
};